customElements.get("product-info") || customElements.define("product-info", class extends HTMLElement {
    quantityInput = void 0;
    quantityForm = void 0;
    onVariantChangeUnsubscriber = void 0;
    cartUpdateUnsubscriber = void 0;
    abortController = void 0;
    pendingRequestUrl = null;
    preProcessHtmlCallbacks = [];
    postProcessHtmlCallbacks = [];
    constructor() {
        super(), this.quantityInput = this.querySelector(".quantity__input")
    }
    connectedCallback() {
        this.initializeProductSwapUtility(), this.onVariantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, this.handleOptionValueChange.bind(this)), this.initQuantityHandlers(), this.dispatchEvent(new CustomEvent("product-info:loaded", {
            bubbles: !0
        }))
    }
    addPreProcessCallback(t) {
        this.preProcessHtmlCallbacks.push(t)
    }
    initQuantityHandlers() {
        this.quantityInput && (this.quantityForm = this.querySelector(".product-form__quantity"), this.quantityForm) && (this.setQuantityBoundries(), this.dataset.originalSection || (this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this))))
    }
    disconnectedCallback() {
        this.onVariantChangeUnsubscriber(), this.cartUpdateUnsubscriber?.()
    }
    initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push(t => t.querySelectorAll(".scroll-trigger").forEach(t => t.classList.add("scroll-trigger--cancel"))), this.postProcessHtmlCallbacks.push(t => {
            window?.Shopify?.PaymentButton?.init(), window?.ProductModel?.loadShopifyXR()
        })
    }
    handleOptionValueChange({
        data: {
            event: t,
            target: e,
            selectedOptionValues: i
        }
    }) {
        var s, r;
        this.contains(t.target) && (this.resetProductFormState(), t = e.dataset.productUrl || this.pendingRequestUrl || this.dataset.url, this.pendingRequestUrl = t, s = this.dataset.url !== t, r = "true" === this.dataset.updateUrl && s, this.renderProductInfo({
            requestUrl: this.buildRequestUrlWithParams(t, i, r),
            targetId: e.id,
            callback: s ? this.handleSwapProduct(t, r) : this.handleUpdateProductInfo(t)
        }))
    }
    resetProductFormState() {
        var t = this.productForm;
        t?.toggleSubmitButton(!0), t?.handleErrorMessage()
    }
    handleSwapProduct(i, s) {
        return t => {
            this.productModal?.remove();
            var e = this.getSelectedVariant(t.querySelector(s ? "product-info[id^='MainProduct']" : "product-info"));
            this.updateURL(i, e?.id), s ? (document.querySelector("head title").innerHTML = t.querySelector("head title").innerHTML, HTMLUpdateUtility.viewTransition(document.querySelector("main"), t.querySelector("main"), this.preProcessHtmlCallbacks, this.postProcessHtmlCallbacks)) : HTMLUpdateUtility.viewTransition(this, t.querySelector("product-info"), this.preProcessHtmlCallbacks, this.postProcessHtmlCallbacks)
        }
    }
    renderProductInfo({
        requestUrl: t,
        callback: e
    }) {
        this.abortController?.abort(), this.abortController = new AbortController, fetch(t, {
            signal: this.abortController.signal
        }).then(t => t.text()).then(t => {
            this.pendingRequestUrl = null;
            t = (new DOMParser).parseFromString(t, "text/html");
            e(t)
        }).then(() => { }).catch(t => {
            "AbortError" === t.name ? console.log("Fetch aborted by user") : console.error(t)
        })
    }
    getSelectedVariant(t) {
        t = t.querySelector("variant-selects [data-selected-variant]")?.innerHTML;
        return t ? JSON.parse(t) : null
    }
    buildRequestUrlWithParams(t, e, i = !1) {
        var s = [];
        return i || s.push("section_id=" + this.sectionId), e.length && s.push("option_values=" + e.join(",")), t + "?" + s.join("&")
    }
    updateOptionValues(t) {
        t = t.querySelector("variant-selects");
        t && HTMLUpdateUtility.viewTransition(this.variantSelectors, t, this.preProcessHtmlCallbacks)
    }
    handleUpdateProductInfo(r) {
        return s => {
            var t, e, i = this.getSelectedVariant(s);
            this.updateOptionValues(s), this.updateURL(r, i?.id), this.updateVariantInputs(i?.id);

            console.log('[handleUpdateProductInfo] called, variant:', i?.id, 'width:', window.innerWidth);

            if (!i) {
                this.setUnavailable();
                return;
            }

            // Standard innerHTML updater for non-swiper elements
            const updateEl = (id, hideFn = () => false) => {
                var src = s.getElementById(id + "-" + this.sectionId),
                    tgt = this.querySelector(`#${id}-` + this.dataset.section);
                if (src && tgt) {
                    tgt.innerHTML = src.innerHTML;
                    tgt.classList.toggle("hidden", hideFn(src));
                }
            };

            // Full element replacement for swiper-containers.
            // This triggers disconnectedCallback (destroy old Swiper)
            // then connectedCallback (initialize fresh Swiper). No timers.
            const replaceSwiper = (id) => {
                var src = s.getElementById(id + "-" + this.sectionId),
                    tgt = this.querySelector(`#${id}-` + this.dataset.section);
                console.log(`[replaceSwiper] ${id}: src=${!!src}, tgt=${!!tgt}, sectionId=${this.sectionId}, section=${this.dataset.section}`);
                if (src && tgt) {
                    console.log(`[replaceSwiper] ${id}: tgt.swiper BEFORE =`, !!tgt.swiper, 'initialized:', tgt.initialized);
                    var clone = src.cloneNode(true);
                    tgt.replaceWith(clone);
                    // After replaceWith, 'clone' is in the DOM. Check if connectedCallback fired.
                    console.log(`[replaceSwiper] ${id}: clone.swiper AFTER =`, !!clone.swiper, 'initialized:', clone.initialized, 'inDOM:', document.contains(clone));
                } else {
                    console.warn(`[replaceSwiper] ${id}: SKIPPED - src or tgt not found`);
                }
            };

            // Update prices, SKU, inventory, etc.
            updateEl("price");
            updateEl("price-mobile");
            updateEl("price-title");
            updateEl("price-button");
            updateEl("sticky-price-button");
            updateEl("Sku", ({ classList: c }) => c.contains("hidden"));
            updateEl("Inventory", ({ innerText: t }) => "" === t);
            updateEl("Volume");
            updateEl("Price-Per-Item", ({ classList: c }) => c.contains("hidden"));

            // Replace sliders: thumbnails first so gallery's thumbs-swiper can find them
            replaceSwiper("Slider-Thumb");
            replaceSwiper("Slider-Gallery");

            // After replaceWith, the browser hasn't laid out the new elements yet,
            // so Swiper initialized with 0 dimensions (breaks swipe on mobile).
            // requestAnimationFrame runs after layout, before paint — one frame, zero perf cost.
            requestAnimationFrame(() => {
                this.querySelectorAll('swiper-container').forEach(el => {
                    if (el.swiper) el.swiper.update();
                });
            });


            // Scroll to gallery on mobile
            if (window.innerWidth < 769 && (document.body.classList.contains("template-product") || document.body.classList.contains("product"))) {
                t = document.getElementById("MediaGallery-" + this.sectionId);
                if (t) window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - 100, behavior: "smooth" });
            }

            // Update form classes
            t = s.getElementById("ProductForm-" + this.sectionId);
            e = document.getElementById("ProductForm-" + this.dataset.section);
            if (t && e) e.classList = t.classList;

            // Update submit button state
            this.productForm?.toggleSubmitButton(
                s.getElementById("ProductSubmitButton-" + this.sectionId)?.hasAttribute("disabled") ?? true,
                window.variantStrings.soldOut
            );

            // Publish variant change event
            publish(PUB_SUB_EVENTS.variantChange, {
                data: { sectionId: this.sectionId, html: s, variant: i }
            });
        }
    }


    updateVariantInputs(e) {
        this.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-` + this.dataset.section).forEach(t => {
            t = t.querySelector('input[name="id"]');
            t.value = e ?? "", t.dispatchEvent(new Event("change", {
                bubbles: !0
            }))
        })
    }
    updateURL(t, e) {
        this.querySelector("share-button")?.updateUrl("" + window.shopUrl + t + (e ? "?variant=" + e : "")), "false" !== this.dataset.updateUrl && window.history.replaceState({}, "", t + (e ? "?variant=" + e : ""))
    }
    setUnavailable() {
        this.productForm?.toggleSubmitButton(!0, window.variantStrings.unavailable);
        var t = ["price", "Inventory", "Sku", "Price-Per-Item", "Volume-Note", "Volume", "Quantity-Rules"].map(t => `#${t}-` + this.dataset.section).join(", ");
        document.querySelectorAll(t).forEach(({
            classList: t
        }) => t.add("hidden"))
    }
    updateMedia(t, e) {
        if (e) return e = document.querySelector(`.images swiper-container #Slide-${this.dataset.section}-` + e)?.dataset.swiperSlideIndex, void document.querySelector(".images swiper-container")?.swiper?.slideToLoop(e)
    }
    setQuantityBoundries() {
        var t = {
            cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
            min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
            max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
            step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1
        };
        let e = t.min;
        var i = null === t.max ? t.max : t.max - t.cartQuantity;
        null !== i && (e = Math.min(e, i)), t.min <= t.cartQuantity && (e = Math.min(e, t.step)), this.quantityInput.min = e, i ? this.quantityInput.max = i : this.quantityInput.removeAttribute("max"), this.quantityInput.value = e, publish(PUB_SUB_EVENTS.quantityUpdate, void 0)
    }
    fetchQuantityRules() {
        var t = this.productForm?.variantIdInput?.value;
        t && fetch(this.dataset.url + `?variant=${t}&section_id=` + this.dataset.section).then(t => t.text()).then(t => {
            (new DOMParser).parseFromString(t, "text/html")
        }).catch(t => console.error(t))
    }
    updateQuantityRules(t, e) {
        if (this.quantityInput) {
            this.setQuantityBoundries();
            var i, s = e.getElementById("Quantity-Form-" + t);
            for (i of [".quantity__input", ".quantity__rules", ".quantity__label"]) {
                var r, a = this.quantityForm.querySelector(i),
                    n = s.querySelector(i);
                if (a && n)
                    if (".quantity__input" === i)
                        for (r of ["data-cart-quantity", "data-min", "data-max", "step"]) {
                            var o = n.getAttribute(r);
                            null !== o ? a.setAttribute(r, o) : a.removeAttribute(r)
                        } else a.innerHTML = n.innerHTML
            }
        }
    }
    get productForm() {
        return this.querySelector("product-form")
    }
    get productModal() {
        return document.querySelector("#ProductModal-" + this.dataset.section)
    }
    get pickupAvailability() {
        return this.querySelector("pickup-availability")
    }
    get variantSelectors() {
        return this.querySelector("variant-selects")
    }
    get relatedProducts() {
        var t = SectionId.getIdForSection(SectionId.parseId(this.sectionId), "related-products");
        return document.querySelector(`product-recommendations[data-section-id^="${t}"]`)
    }
    get quickOrderList() {
        var t = SectionId.getIdForSection(SectionId.parseId(this.sectionId), "quick_order_list");
        return document.querySelector(`quick-order-list[data-id^="${t}"]`)
    }
    get sectionId() {
        return this.dataset.originalSection || this.dataset.section
    }
}), customElements.get("sticky-variant-picker") || customElements.define("sticky-variant-picker", class extends HTMLElement {
    constructor() {
        super(), this.originalVariantSelector = null, this.isVisible = !1, this.observer = null, this.stickyAddToCartBtn = null, this.originalForm = null, this.observeTarget = null
    }
    connectedCallback() {
        this.originalVariantSelector = document.querySelector(`variant-selects[data-section="${this.dataset.section}"]`), this.originalForm = document.querySelector("#ProductForm-" + this.dataset.section), this.stickyAddToCartBtn = this.querySelector("[data-sticky-add-to-cart]"), this.originalForm && (this.initializeIntersectionObserver(), this.initializeStickyEvents(), this.setupVariantSync(), this.setupAddToCartSync(), this.setupButtonObserver(), this.onVariantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.handleVariantChange.bind(this)), setTimeout(() => {
            this.syncEverything()
        }, 100))
    }
    disconnectedCallback() {
        this.observer && this.observer.disconnect(), this.buttonObserver && this.buttonObserver.disconnect(), this.onVariantChangeUnsubscriber && this.onVariantChangeUnsubscriber(), window.removeEventListener("scroll", this.throttledScrollHandler)
    }
    initializeIntersectionObserver() {
        this.observeTarget = this.originalVariantSelector || this.originalForm;
        this.observer = new IntersectionObserver(t => {
            t.forEach(t => {
                t.isIntersecting ? this.hideSticky() : this.showSticky()
            })
        }, {
            root: null,
            rootMargin: "-50px 0px 1000px 0px",
            threshold: 0
        }), this.observeTarget && this.observer.observe(this.observeTarget)
    }
    showSticky() {
        this.isVisible || (this.isVisible = !0, this.classList.add("sticky-variant-picker--visible"), document.body.classList.add("sticky-variant-picker-shown"), this.syncEverything())
    }
    hideSticky() {
        this.isVisible && (this.isVisible = !1, this.classList.remove("sticky-variant-picker--visible"), document.body.classList.remove("sticky-variant-picker-shown"))
    }
    initializeStickyEvents() {
        this.addEventListener("change", t => {
            t.target.matches(".swatch-input__input") && this.handleStickySwatchChange(t)
        })
    }
    handleStickySwatchChange(t) {
        var t = t.target,
            e = t.dataset.originalInputId,
            e = document.getElementById(e);
        e && (e.checked = !0, e.dispatchEvent(new Event("change", {
            bubbles: !0
        })), e = this.querySelector("[data-sticky-selected-value]")) && (e.textContent = t.value)
    }
    setupVariantSync() {
        this.originalVariantSelector && (this.originalChangeListener && this.originalVariantSelector.removeEventListener("change", this.originalChangeListener), this.originalChangeListener = t => {
            t.target.matches('input[type="radio"]') && this.syncFromOriginal(t.target)
        }, this.originalVariantSelector.addEventListener("change", this.originalChangeListener))
    }
    syncFromOriginal(t) {
        var e = this.querySelector(`[data-original-input-id="${t.id}"]`);
        e && (e.checked = t.checked, t.checked) && (e = this.querySelector("[data-sticky-selected-value]")) && (e.textContent = t.value)
    }
    setupAddToCartSync() {
        this.stickyAddToCartBtn && this.originalForm && this.stickyAddToCartBtn.addEventListener("click", t => {
            t.preventDefault();
            t = this.originalForm.querySelector('button[type="submit"]');
            t && t.click()
        })
    }
    setupButtonObserver() {
        let t = this.originalForm?.querySelector('button[type="submit"]');
        t && this.stickyAddToCartBtn && (this.buttonObserver = new MutationObserver(() => {
            this.syncAddToCartState(t)
        }), this.buttonObserver.observe(t, {
            attributes: !0,
            childList: !0,
            subtree: !0,
            attributeFilter: ["disabled", "class"]
        }), this.syncAddToCartState(t))
    }
    syncAddToCartState(t) {
        var e, i, s;
        this.stickyAddToCartBtn && t && (i = (e = this.stickyAddToCartBtn).querySelector(".sticky-add-to-cart-text"), s = t.querySelector("span"), i && s && (i.textContent = s.textContent), e.disabled = t.disabled, e.classList.toggle("loading", t.classList.contains("loading")), t.classList.contains("btn--unavailable") ? e.classList.add("btn--unavailable") : e.classList.remove("btn--unavailable"))
    }
    syncEverything() {
        this.originalVariantSelector = document.querySelector(`variant-selects[data-section="${this.dataset.section}"]`), this.originalForm = document.querySelector("#ProductForm-" + this.dataset.section), this.originalForm && (this.originalVariantSelector && this.originalVariantSelector.querySelectorAll('input[type="radio"]:checked').forEach(t => {
            this.syncFromOriginal(t)
        }), this.setupVariantSync(), this.buttonObserver && this.buttonObserver.disconnect(), this.setupButtonObserver(), this.observer && this.observer.disconnect(), this.initializeIntersectionObserver())
    }
    handleVariantChange({
        data: {
            sectionId: t
        }
    }) {
        t === this.dataset.section && setTimeout(() => {
            this.syncEverything()
        }, 10)
    }
});